import AboutTab from './AboutTab'

export default AboutTab
